export const APP_SETTINGS_LOADING = "APP_SETTINGS_LOADING";
export const APP_SETTINGS_SUCCESS = "APP_SETTINGS_SUCCESS";
export const CATCH_ERROR_APP_SETTINGS = "CATCH_ERROR_APP_SETTINGS";
export const CLEAR_ERROR_APP_SETTINGS = "CLEAR_ERROR_APP_SETTINGS";
